const openPopup = document.querySelectorAll('.popup-open');
let i;
for (i = 0; i < openPopup.length; i++) {
    openPopup[i].addEventListener('click', function(event){
        event.preventDefault();
        const popupId = this.getAttribute('data-popup');
        togglePopup(popupId);
    });
}

const overlay = document.querySelectorAll('.popup-overlay');
if(overlay) {
    overlay.forEach(function(overlayItem) {
        overlayItem.addEventListener('click', function() {
            const popupId = this.closest('.popup').getAttribute('id');
            togglePopup(popupId);
        });
    });
}

const closePopup = document.querySelectorAll('.popup-close');
for (i = 0; i < closePopup.length; i++) {
    closePopup[i].addEventListener('click', function(event){
        event.preventDefault();
        const popupId = this.closest('.popup').getAttribute('id');
        togglePopup(popupId);
        removeHash();
    });
}

document.onkeydown = function(evt) {
    evt = evt || window.event;
    let isEscape = false;
    if ("key" in evt) {
        isEscape = (evt.key === "Escape" || evt.key === "Esc");
    } else {
        isEscape = (evt.keyCode === 27);
    }
    if (isEscape && document.body.classList.contains('popup-active')) {
        const activePopup = document.querySelector('.popup.popup-open');
        if (activePopup) {
            const popupId = activePopup.getAttribute('id');
            togglePopup(popupId);
        }
    }
};

function togglePopup(popupId = '') {
    const body = document.querySelector('body');
    if (popupId) {
        const popup = document.getElementById(popupId);
        if (popup.classList.contains('popup-open')) {
            removeHash();
        }
        popup.classList.toggle('popup-open');
        const isAnyPopupOpen = document.querySelector('.popup.popup-open') !== null;
        body.classList.toggle('popup-active', isAnyPopupOpen);
    }
}

function removeHash() {
    // Check if the current URL has a hash
    if (window.location.hash) {
        // Remove the hash from the URL
        const newUrl = window.location.href.split('#')[0];
        // Replace the current URL without the hash
        window.history.replaceState({}, document.title, newUrl);
    }
}
